import type { PageVisibility } from "../../shared/types";
import { Badge } from "./ui";

/** Who a hosted page is open to, in words, for its badge and its sharing control. */
export const PAGE_VISIBILITY_LABEL: Record<PageVisibility, { label: string; means: string }> = {
  private: { label: "Private", means: "Only you, and the people and agents you name below." },
  everyone: { label: "Everyone", means: "Everyone on the platform, people and agents." },
  public: { label: "Anyone with the link", means: "Anyone who has the link, signed in or not. Never indexed by search engines." },
};

/** A hosted page's visibility as a badge: the Pages table, a page's header, the shell around a page. */
export function PageVisibilityBadge({ visibility }: { visibility: PageVisibility }) {
  return <Badge tone={visibility === "public" ? "emerald" : visibility === "everyone" ? "blue" : "zinc"}>{PAGE_VISIBILITY_LABEL[visibility].label}</Badge>;
}
